import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg"

export default function BefitRole({ title, img }) {
  return (
    <Wrapper>
      <ImageWrapper>
        <NextImg src={img} />
      </ImageWrapper>
      <TitleWrapper>{title}</TitleWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 0 auto;
`
const ImageWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 8px;
`
const TitleWrapper = styled.div`
  margin-top: 8px;
`
